export const agriculture_annual_report = [
  {
    id: 1,
    name: 'annual report 2024-2025',
    summary: 'shortsummary/annual report 2024-2025.html',
    link: 'annual report 2024-2025.pdf',
    audio_en: 'audio/en/annual report 2024-2025_en.mp3',
    audio_af: 'audio/af/annual report 2024-2025_af.mp3',
    audio_xh: 'audio/xh/annual report 2024-2025_xh.mp3'
  }
];  